<div *ngIf="miembro" class="tarjeta-miembro">
    <div class="foto-nombre" [ngStyle]="{display: miembro.imagen ? 'flex' : 'auto'}">
      <div class="campo">
        <label>
          Nombre y Apellido
        </label>
        <input type="text" value={{miembro.name}} readonly>
      </div>
      <img class="foto" src={{miembro.imagen}} *ngIf="miembro.imagen" alt="" (click)="currentFotoMiembro = miembro.imagen">
    </div>
    <div class="campo" *ngIf="!esCitofonia">
      <label>
        Tipo de documento
      </label>
      <input type="text" value={{miembro.type_document}} readonly>
    </div>
    <div class="campo" *ngIf="!esCitofonia">
      <label>
        Documento
      </label>
      <input type="text" value={{miembro.number_document}} readonly>
    </div>
    <div class="campos-celular campo">
      <div>
        <label>Indicativo</label>
        <input type="text" class="indicativo" value={{miembro.indicative}} readonly>
      </div>
      <div class="contenedor-celular">
        <label>Celular</label>
        <input type="number" value={{miembro.phone}} readonly>
      </div>
    </div>
    <div class="campo">
      <label>
        Invitados autorizados
      </label>
      <div class="botones-miembro">
        <button [class.boton-primario]="miembro.guests_allowed === 1">Activo</button>
        <button [class.boton-primario]="miembro.guests_allowed === 0">Inactivo</button>
      </div>
    </div>
    <div class="campo contenedor-wa" *ngIf="esCitofonia">
      <label>
        Actualmente se encuentra en su apartamento
      </label>
      <a 
        [href]="'https://api.whatsapp.com/send?phone=' + telefonoWhatsApp(miembro)"
        className='widget-restaurante' 
        key="restaurante-wa"
        target="noopener noreferrer"
      >
        <img class="logo-wa" src="./../../../../assets/logos/whatsapp.png" alt="Logo WhatsApp">
      </a>
    </div>
</div>

<div class="contenedor-imagen-grande" *ngIf="currentFotoMiembro">
    <div>
        <img class="x-icon" src="./../../../../assets/iconos/x-icon.svg" alt="" (click)="currentFotoMiembro=''">
        <img class="imagen-grande" [src]="currentFotoMiembro" alt="">
    </div>
</div>

<mat-spinner *ngIf="miembro === undefined || cargando"></mat-spinner>

<div class="mensaje-sin-datos" *ngIf="miembro === null">
    Lo sentimos, no se encontró información sobre este residente.
</div>